export const MIXPANEL_TOKEN = "a98ea9bb660140b48d09a4d7ebc34f65"

export const TRACK_EVENTS = {
  ACTIVATED: "BZ WP plugin activated",
  DEACTIVATED: "BZ WP plugin deactivated",
  AUTHENTICATION_MISMATCH: "BZ WP plugin authentication mismatch",
  AUTHENTICATION_ERROR: "BZ WP plugin authentication error",
  WHITELIST_UPDATED: "BZ WP Plugin IP whitelisting updated"
}
